<template>
    <div class="main">
        <div class="header">
            <img src="../../assets/anniversary/logo.png" alt="" width="100%">
        </div>
        <div class="content_person">
            <div class="name">{{ form.Name }}</div>
            <div class="department">{{ form.Department }}</div>
            <div style="letter-spacing: 1px;">新健帆二十年暨第十七届健帆节庆典</div>
            <div style="letter-spacing: 2px;">珠海大剧院·2024.02.28</div>
        </div>
        <div class="content_card">
            <div v-if="form.meal === '是'">
                <div class="item">
                    <div style="border: 1px #ffffff solid;padding: 4px 10px;width: 38%;text-align: center;">庆典座位</div>
                    <div style="width: 10%;text-align: center;">----</div>
                    <div style="border: 1px #ffffff solid;padding: 4px 10px;width: 38%;text-align: center;">晚宴桌号</div>
                </div>
                <div class="item" style="font-size: 20px;font-weight: bold;padding: 0px 15px 15px 0;">
                    <div style="width: 50%;text-align: center;">{{ form.Seat }}</div>
                    <div style="width: 50%;text-align: center;">{{ form.TableNum }}</div>
                </div>
            </div>
            <div v-else>
                <div class="item" style="display: flex;justify-content: center;">
                    <div style="border: 1px #ffffff solid;padding: 4px 10px;width: 38%;text-align: center;">庆典座位</div>
                </div>
                <div class="item" style="display: flex;justify-content: center;font-size: 20px;font-weight: bold;padding: 0px 15px 15px 0;">
                    <div style="width: 50%;text-align: center;">{{ form.Seat }}</div>
                </div>
            </div>

        </div>
        <van-tabs v-model="active" type="card" color="#5C76FF" background="#354ED2" title-active-color="#fffff" title-inactive-color="#ffffff" style="z-index: 1;">
            <van-tab title="座位安排">
                <div class="content_tab">
                    <div class="title">
                        <img src="../../assets/anniversary/icon.svg" width="3%">
                        <div class="font">珠海大剧院座位安排</div>
                        <img src="../../assets/anniversary/icon.svg" width="3%" style="transform: rotateY(180deg);">
                    </div>
                    <div style="width: 100%;text-align: center;">
                        <img src="../../assets/anniversary/seatMap.png" @click="onPreview" width="98%">
                        <div style="font-size: 14px;color: red;">注：可点击放大查看</div>
                    </div>
                    

                    <div style="display: flex;margin-top: 20px;">
                        <div>
                            <div class="area">
                                <div class="square" style="background: #6FF;"></div>
                                <div>公司董监高+重要嘉宾席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #70AD47;"></div>
                                <div>5年员工席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #FCE4D6;"></div>
                                <div>10年、15年员工席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #8EA9DB;"></div>
                                <div>总部总监级及以上员工席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #00B0F0;"></div>
                                <div>嘉宾席A区</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #7030A0;"></div>
                                <div>经销商席</div>
                            </div>
                        </div>
                        <div>
                            <div class="area">
                                <div class="square" style="background: #B2B2B2;"></div>
                                <div>供应商席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #BF8F00;"></div>
                                <div>嘉宾席B区</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #F6F;"></div>
                                <div>总部经理级+营销省区负责人席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #FF0;"></div>
                                <div>其他驻外返珠员工席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #F4B084;"></div>
                                <div>其他员工席</div>
                            </div>
                            <div class="area">
                                <div class="square" style="background: #FFF;"></div>
                                <div>设备和工作人员席</div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="通勤车安排">
                <div class="content_tab">
                    <div class="title">
                        <img src="../../assets/anniversary/icon.svg" width="3%">
                        <div class="font">通勤车安排</div>
                        <img src="../../assets/anniversary/icon.svg" width="3%" style="transform: rotateY(180deg);">
                    </div>
                    <div style="padding: 0 12px;">


                        <!-- 前往珠海大剧院 -->
                        <div style="display: flex;color: #F08300;font-size: 20px;padding: 20px 0;">
                            <img src="../../assets/anniversary/arrow.svg" width="5%">
                            <div style="padding-left: 8px;font-weight: bold;">前往珠海大剧院</div>
                        </div>
                        <van-radio-group v-model="goRadio" direction="horizontal" checked-color="#190F90">
                            <van-radio name="健帆园线" style="width: 40%;">健帆园南区线</van-radio>
                            <van-radio name="金鼎健帆园线" style="width: 40%;">金鼎健帆园线</van-radio>
                        </van-radio-group>
                        <img v-if="goRadio === '健帆园线'" src="../../assets/anniversary/go1.png" width="100%" style="padding: 15px 0;">
                        <img v-else src="../../assets/anniversary/go2.png" width="100%" style="padding: 15px 0;">


                        <!-- 庆典结束返程 -->
                        <div v-if="form.meal === '是'">
                            <div style="display: flex;color: #F08300;font-size: 20px;padding: 20px 0;">
                                <img src="../../assets/anniversary/arrow.svg" width="5%">
                                <div style="padding-left: 8px;font-weight: bold;">庆典结束前往晚宴</div>
                            </div>
                            <div style="font-size: 14px;color: #E60013;padding-bottom: 10px;">可步行前往，路程约40分钟，请充分预留时间，务必于18:30前到达就坐。</div>
                            <!-- <van-radio-group v-model="backRadio" direction="horizontal" checked-color="#190F90" icon-size="16px">
                                <van-radio name="晚宴线" style="width: 100%;">晚宴线</van-radio>
                            </van-radio-group> -->
                            <div style="padding: 15px 0;">
                                <img src="../../assets/anniversary/back3.png" width="100%">
                            </div>
                            <!-- <div style="color: #190F90;">晚宴注意事项：<br>1.晚宴着装不作要求，结合个人需要搭配。<br>2.酒后请勿驾车，餐后请合规、安全返程。</div> -->
                        </div>
                        <div v-else>
                            <div style="display: flex;color: #F08300;font-size: 20px;padding: 20px 0;">
                                <img src="../../assets/anniversary/arrow.svg" width="5%">
                                <div style="padding-left: 8px;font-weight: bold;">庆典结束返程</div>
                            </div>
                            <van-radio-group v-model="backRadio" direction="horizontal" checked-color="#190F90">
                                <van-radio name="市区线" style="width: 40%;">市区线</van-radio>
                                <van-radio name="公司线" style="width: 40%;">公司线</van-radio>
                            </van-radio-group>
                            <div style="min-height: 190px;padding: 15px 0;">
                                <img v-if="backRadio === '市区线'" src="../../assets/anniversary/back1.png" width="100%">
                                <img v-else src="../../assets/anniversary/back2.png" width="100%">
                            </div>
                        </div>



                        <!-- 晚宴结束返程 -->
                        <div v-if="form.meal === '是'">
                            <div style="display: flex;color: #F08300;font-size: 20px;padding: 20px 0;">
                                <img src="../../assets/anniversary/arrow.svg" width="5%">
                                <div style="padding-left: 8px;font-weight: bold;">晚宴结束返程</div>
                            </div>
                            <van-radio-group v-model="eatRadio" direction="horizontal" checked-color="#190F90">
                                <van-radio name="市区线" style="width: 40%;">市区线</van-radio>
                                <van-radio name="公司线" style="width: 40%;">公司线</van-radio>
                            </van-radio-group>
                            <div style="min-height: 180px;padding: 15px 0;">
                                <img v-if="eatRadio === '市区线'" src="../../assets/anniversary/eat1.png" width="100%">
                                <img v-else src="../../assets/anniversary/eat2.png" width="100%">
                            </div>
                        </div>

                    </div>

                    <div v-if="form.meal === '是'">
                        <div style="color: #190F90;padding: 10px 16px;line-height: 1.5;text-align: justify;">
                            注意事项： <br>1、自驾车辆凭票在大剧院①号②号停车场免费停放4小时，车位有限，为避免拥堵，建议统一乘坐通勤车辆。
                            <br>2、酒后请勿驾车，餐后请合规、安全返程。
                        </div>
                    </div>
                    <div v-else>
                        <div style="color: #190F90;padding: 10px 16px;line-height: 1.5;text-align: justify;">
                            注意事项： <br>自驾车辆凭票在大剧院①号②号停车场免费停放4小时，车位有限，为避免拥堵，建议统一乘坐通勤车辆。
                        </div>
                    </div>

                </div>
            </van-tab>
            <van-tab title="注意事项">
                <div class="content_tab">
                    <!-- <div class="title">
                        <img src="../../assets/anniversary/icon.svg" width="3%">
                        <div class="font">注意事项 </div>
                        <img src="../../assets/anniversary/icon.svg" width="3%" style="transform: rotateY(180deg);">
                    </div> -->
                    <!-- <div style="color: #190F90;">
                        <div style="display: flex; background-color: #EBEDFB;font-weight: bold;">
                            <div style="width: 100px; padding: 10px 10px 10px 50px;">时间</div>
                            <div style="flex: 1; padding: 10px;">议程事项</div>
                        </div>
                        <div class="line">
                            <div style="display: flex;font-size: 14px;" v-for="item in columns" :key="item.time">
                                <div style="width: 100px; padding: 10px 10px 10px 50px;">{{ item.time }}</div>
                                <div style="flex: 1; padding: 10px;">{{ item.agenda }}</div>
                            </div>
                        </div>
                    </div> -->
                    <div style="color: #190F90;padding: 10px 16px;line-height: 1.5;text-align: justify;">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        “回顾往昔峥嵘岁月,展望健帆璀璨未来”本次活动是健帆人的盛大节日，也是我们传承健帆精神、提升品牌实力的重要平台。届时将会有较多外部嘉宾出席活动，请所有参会人员积极配合组织安排，识大体、顾大局，高标准展现健帆人优良的职业形象和精神面貌。<br><br>
                        注意事项如下：<br>
                        1、着装：男士着深色西装、系领带，女士深色职业套装（西裙或西裤）。<br>
                        2、票务：需持门票进出会场，请妥善保管，按号就坐。<br>
                        3、环境：剧场内不可自行携带食物饮品，禁止吸烟，饮水可在剧场门口自取。<br>
                        4、纪律：会议期间无中场休息，全程摄像转播，请大家遵守秩序，避免迟到早退、随意走动，禁止玩弄手机（请调至静音）。<br><br>

                        如有门票丢失等无法正常入场情况，请及时电联：集团人力资源中心叶冰冰13728609163、李静儿13226642569。
                    </div>
                </div>
            </van-tab>
        </van-tabs>
        <div class="footer">
            <!-- <div style="padding: 12% 0 5% 0;letter-spacing: 10px;">健行二十载 帆扬向未来</div>
            <img src="../../assets/anniversary/logo.png" alt="" width="60%"> -->
        </div>
    </div>
</template>
  
<script>
import { GET, POST } from '@/util/http'
import { ImagePreview } from 'vant';
export default {
    data() {
        return {
            active: 0,
            columns: [
                { time: '14:00', agenda: '开场舞' },
                { time: '14:25', agenda: '领导致辞' },
                { time: '14:35', agenda: '颁奖' },
                { time: '14:45', agenda: '五年员工节目及赠礼' },
                { time: '15:20', agenda: '十年员工节目及赠礼' },
                { time: '15:55', agenda: '十五年员工节目及赠礼' },
                { time: '16:10', agenda: '二十年员工节目及赠礼' },
                { time: '16:40', agenda: '二十年回顾' },
                { time: '17:10', agenda: '结束' }
            ],
            goRadio: '健帆园线',
            backRadio: '市区线',
            eatRadio: '市区线',
            phone: '',
            form: {
                Name: '',
                Phone: '',
                Department: '',
                Seat: '',
                TableNum: '',
                meal: '否',
                Status: false
            }
        }
    },
    mounted() {
        this.phone = this.$route.query.phone
        this.getData()
    },
    methods: {
        async getData() {
            const result = await GET({
                // url: this.$urlWapApi + '/api/anniversary/getPersonByPhone',
                url: 'https://wap.jafron.com:8051/api/anniversary/getPersonByPhone',
                params: {
                    Phone: this.phone
                }
            })
            if (result.success && result.data) {
                console.log(result)
                this.form = result.data
                if (this.form.meal === '是') {
                    this.backRadio = '晚宴线'
                }
                if (!this.form.Status) {
                    await POST({
                        url: 'https://wap.jafron.com:8051/api/anniversary/postAnniversaryData',
                        // url: this.$urlWapApi + '/api/anniversary/postAnniversaryData',
                        params: {
                            _id: this.form._id
                        }
                    })
                }
            } else {
                this.$router.push('/anniversary/error')
                // this.$toast.fail('抱歉你不在邀约名单里')
            }
        },
        onPreview() {
            ImagePreview({
                images: ['https://jafron.oss-cn-shenzhen.aliyuncs.com/images/seatMap.png'],
                showIndex: false
            })
        }
    }
}
</script>
  
<style>
.main {
    background-image: url('../../assets/anniversary/bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #c30819 ;
    background-attachment:fixed;
}

.header {
    /* display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px; */
    color: #ffffff;
}

.content_person {
    text-align: center;
    color: #ffffff;
    padding: 25px 0 15px 0;
    line-height: 30px;
    font-weight: 500;
    font-size: 18px;
}

.name {
    font-size: 40px;
    font-weight: 600;
}

.department {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.60);
    padding: 10px 0;
    font-weight: normal;
}

.content_card {
    border-radius: 4px;
    margin: 0px 5px;
    padding: 12px 15px;
    background-image: url('../../assets/anniversary/card_bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    color: #ffffff;
}
.content_tab {
    background-color: #ffffff;
    margin: 0 16px;
    padding: 20px 0;
}
.van-tabs__nav--card {
    height: 50px;
}
.van-tabs--card>.van-tabs__wrap {
    height: 50px;
}
.van-tab__text--ellipsis {
    font-size: 18px;
}
.title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}

.font {
    color: #190F90;
    font-size: 20px;
    font-weight: bold;
    padding: 0 10px;
}

.line {
    background: url('../../assets/anniversary/line.svg') no-repeat;
    background-size: 15% 90%;
    background-position: 0% 45%;
}
.area {
    display: flex;
    width: 100%;
    padding: 5px;
    align-items: center;
    font-size: 12px;
}
.square{
    width:10px;
    height:10px;
    background:#ccc;
    margin-right: 5px;
    border: 1px solid #000;
}
.footer {
    width: 100%;
    height: 150px;
    background-image: url('../../assets/anniversary/footer_bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    color: #ffffff;
    text-align: center;
    font-weight: bold;
}
.van-radio--horizontal {
    margin: 0px;
}
.van-radio {
    border: 1px solid #190F90;
    background: rgba(53, 78, 210, 0.10);
    padding: 8px 12px;
}
.van-radio-group--horizontal {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
  